import React, { useEffect, useState } from "react";

function ExpertTrainner() {
  const [trainnerData, setTrainnerData] = useState([]);
  const dataArray = [
    {
      image: "/images/talha.jpg",
      name: "Talha Uzair",
      position: "Professional Trainer",
    },
    {
      image: "/images/umer.jpg",
      name: "Umer Butt",
      position: "Professional Trainer",
    },
    {
      image: "/images/amir.png",
      name: "Aamir Jutt",
      position: "Professional Trainer",
    },
  ];
  useEffect(() => {
    setTrainnerData(dataArray);
  }, []);
  return (
    <div className="mt-8 md:mt-10 w-full h-auto p-6 md:p-10 aling-center justify-center text-center">
      <h1 className="text-white font-[700] text-2xl sm:text-3xl md:text-4xl lg:text-4xl 2xl:text-5xl font-bold ">
        EXPERT TRAINERS
      </h1>
      <p className="text-md sm:text-lg md:text-lg text-center m-auto w-[96%] md:w-[75%] lg:w-[60%]  mt-4 md:mt-6 text-nav_option">
        Our vision is to build a vibrant fitness community where people of all
        backgrounds can discover their potential, break barriers, and transform
        their lives. By fostering a culture of passion, dedication, and
        innovation, Fit Streak strives to become a leader in the fitness
        industry and a trusted partner in every fitness journey.
      </p>
      <div className="mt-6 flex flex-col lg:flex-row w-[90%] lg:w-[100%] sm:w-[96%]  xl:w-[95%] 2xl:w-[90%] m-auto justify-center lg:space-x-6 ">
        {dataArray.map((data, index) => (
          <div
            key={index}
            className="w-[90%] m-auto lg:m-0 sm:w-[400px] md:w-[500px] lg:w-[400px] xl:w-[500px] 2xl:w-[620px] mt-6 lg:mt-0 relative hover:border-[4px] hover:border-red bg-[#1c1c1c] h-auto z-0 rounded-[10px]"
          >
            <img
              src={data.image}
              alt="male trainer"
              className="w-full h-auto rounded-t-[10px] rounded-b-[10px]"
            />
            <div className="w-full h-auto md:h-48 bg-custom-gradient absolute bottom-0 z-10 rounded-b-[10px] p-4  flex flex-col justify-end items-center text-center">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-2xl xl:text-3xl 2xl:text-4xl text-white font-bold">
                {data.name}
              </h1>
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-lg xl:text-xl 2xl:text-2xl text-nav_option font-semibold md:mb-4 mt-2">
                {data.position}
              </h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ExpertTrainner;
